(function () {
  var IMG = {};
  var ORDER = [];
  var ready = false;
  var writing = false;
  var hideTimer = null;

  function addStyle() {
    if (document.getElementById('atc-ds-style')) return;
    var s = document.createElement('style');
    s.id = 'atc-ds-style';
    s.textContent = [
      '.atc-ds-row{display:flex;gap:10px;flex-wrap:wrap;margin-top:8px;}',
      '.atc-ds-sw{-webkit-appearance:none;appearance:none;background:transparent;color:inherit;font:inherit;cursor:pointer;',
      'border:1px solid rgba(128,128,128,.45);border-radius:10px;padding:6px;display:flex;flex-direction:column;align-items:center;gap:6px;width:94px;}',
      '.atc-ds-sw img{width:80px;height:80px;object-fit:cover;border-radius:6px;display:block;background:rgba(128,128,128,.15);}',
      '.atc-ds-sw span{font-size:12px;line-height:1.2;text-align:center;opacity:.85;}',
      '.atc-ds-sw[aria-pressed="true"]{border-color:currentColor;box-shadow:inset 0 0 0 1px currentColor;}',
      '.atc-ds-sw[aria-pressed="true"] span{opacity:1;font-weight:600;}',
      '.atc-ds-hidden{display:none!important;}',
      '.atc-ds-pop{position:fixed;left:0;top:0;z-index:9999;pointer-events:none;opacity:0;visibility:hidden;transition:opacity .12s ease;background:#fff;border-radius:14px;padding:6px;box-shadow:0 12px 40px rgba(0,0,0,.5);}',
      '.atc-ds-pop.is-on{opacity:1;visibility:visible;}',
      '.atc-ds-pop img{display:block;width:380px;height:380px;object-fit:contain;border-radius:10px;}',
      '@media (max-width:749px){.atc-ds-sw{width:84px;}.atc-ds-sw img{width:70px;height:70px;}.atc-ds-pop img{width:min(88vw,400px);height:min(88vw,400px);}}'
    ].join('');
    document.head.appendChild(s);
  }

  function sized(src, w) {
    if (!src) return '';
    return src.split('?')[0] + '?width=' + w;
  }

  function popup() {
    var p = document.getElementById('atc-ds-pop');
    if (p) return p;
    p = document.createElement('div');
    p.id = 'atc-ds-pop';
    p.className = 'atc-ds-pop';
    p.innerHTML = '<img alt="">';
    document.body.appendChild(p);
    return p;
  }

  // Above the swatch when there is room, otherwise below it, always kept
  // inside the viewport (the popup is large on phones).
  function place(p, el) {
    var r = el.getBoundingClientRect();
    var pw = p.offsetWidth, ph = p.offsetHeight;
    if (!pw || !ph) return;
    var left = r.left + r.width / 2 - pw / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - pw - 8));
    var top = r.top - ph - 10;
    if (top < 8) top = Math.min(r.bottom + 10, window.innerHeight - ph - 8);
    top = Math.max(8, top);
    p.style.left = Math.round(left) + 'px';
    p.style.top = Math.round(top) + 'px';
    p.classList.add('is-on');
  }

  function showPop(el, src) {
    clearTimeout(hideTimer);
    var p = popup();
    var img = p.querySelector('img');
    var want = sized(src, 900);
    p.setAttribute('data-for', want);
    if (img.getAttribute('src') !== want) {
      img.onload = function () { if (p.getAttribute('data-for') === want) place(p, el); };
      img.src = want;
    }
    if (img.complete && img.naturalWidth) place(p, el);
  }

  function hidePop() {
    clearTimeout(hideTimer);
    var p = document.getElementById('atc-ds-pop');
    if (p) p.classList.remove('is-on');
  }

  function designFieldset() {
    var fs = document.querySelectorAll('fieldset');
    for (var i = 0; i < fs.length; i++) {
      var lg = fs[i].querySelector('legend');
      if (lg && /design/i.test(lg.textContent)) return fs[i];
    }
    return null;
  }

  function inputFor(fs, value) {
    var ins = fs.querySelectorAll('input');
    for (var i = 0; i < ins.length; i++) {
      if ((ins[i].value || '').trim() === value) return ins[i];
    }
    return null;
  }

  function syncState(fs, row) {
    var sws = row.querySelectorAll('.atc-ds-sw');
    for (var i = 0; i < sws.length; i++) {
      var v = sws[i].getAttribute('data-value');
      var inp = inputFor(fs, v);
      sws[i].setAttribute('aria-pressed', inp && inp.checked ? 'true' : 'false');
    }
  }

  function build() {
    if (!ready) return;
    var fs = designFieldset();
    if (!fs) return;

    var row = fs.querySelector('.atc-ds-row');
    if (row) { syncState(fs, row); return; }

    writing = true;

    row = document.createElement('div');
    row.className = 'atc-ds-row';

    ORDER.forEach(function (val) {
      var src = IMG[val];
      if (!src) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'atc-ds-sw';
      b.setAttribute('data-value', val);
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML = '<img alt="" loading="lazy"><span></span>';
      b.querySelector('img').src = sized(src, 220);
      b.querySelector('span').textContent = val;

      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var inp = inputFor(fs, val);
        if (inp && !inp.checked) inp.click();
        showPop(b, src);
        hideTimer = setTimeout(hidePop, 3000);
        setTimeout(function () { syncState(fs, row); }, 60);
      });
      b.addEventListener('mouseenter', function () { showPop(b, src); });
      b.addEventListener('mouseleave', hidePop);

      row.appendChild(b);
    });

    if (!row.children.length) { writing = false; return; }

    var kids = Array.prototype.slice.call(fs.children);
    kids.forEach(function (k) {
      if (k.tagName !== 'LEGEND') k.classList.add('atc-ds-hidden');
    });
    fs.appendChild(row);

    syncState(fs, row);
    fs.addEventListener('change', function () { syncState(fs, row); });

    writing = false;
  }

  // Optional per-product swatch pictures: atc.custom_fields -> design_swatches
  // {"Design 1": "https://...", ...}. Without it the swatch shows the first
  // variant image of that design.
  function overrides() {
    var c = window.ATC_CUSTOM_FIELDS;
    return (c && c.design_swatches) || {};
  }

  function load() {
    if (location.pathname.indexOf('/products/') === -1) return;
    var handle = location.pathname.split('/products/')[1].split('?')[0].split('/')[0];
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var idx = -1;
        (d.options || []).forEach(function (o, i) {
          var n = typeof o === 'string' ? o : (o && o.name);
          if (n && /^design$/i.test(String(n).trim())) idx = i;
        });
        if (idx < 0) return;
        var ov = overrides();
        (d.variants || []).forEach(function (v) {
          var val = v.options && v.options[idx];
          if (!val) return;
          if (ORDER.indexOf(val) === -1) ORDER.push(val);
          if (!IMG[val] && ov[val]) IMG[val] = ov[val];
          if (!IMG[val] && v.featured_image && v.featured_image.src) IMG[val] = v.featured_image.src;
        });
        if (!Object.keys(IMG).length) return;
        ready = true;
        addStyle();
        build();
        new MutationObserver(function () { if (!writing) build(); })
          .observe(document.body, { childList: true, subtree: true });
        window.addEventListener('scroll', hidePop, { passive: true });
        window.addEventListener('resize', hidePop);
        document.addEventListener('click', hidePop);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }
})();
